import { http } from '@/api/instance';

export const dataAPI = {
  download_template: () => http.get<File>('/api/import/download_template').then(({ data }) => data),
  import_lead: (formData: FormData) =>
    http
      .post('/api/import/lead', {
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(({ data }) => data),
};

export const dataQuery = {};
